import { SET_COMPANYS, SET_COMPANYS_UPDATED } from '../constants/CompanyConstants';

const initialState = {
  companys: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_COMPANYS: {
      return {
        ...state,
        companys: action.payload,
        updated: false,
      };
    }

    case SET_COMPANYS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default:
      return state;
  }
}
